module.exports = "<div class=\"spinner-container\" *ngIf=\"type=='PRIMARY'\">\n  <mat-spinner style=\"margin: auto\"></mat-spinner>\n</div>\n<div class=\"loader\" *ngIf=\"type=='SECONDARY'\">\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/shared/wait-spinner/wait-spinner.component.html
// module id = 956
// module chunks = 3